
import moment from 'moment-timezone'

export default {
    props: {
        client: { type: Object, required: true },
        guests: { type: Array, default: () => [] },
        method: { type: String, default: null },
        time: { type: String, default: null },
        // Signed token from /book; powers the reschedule/cancel deep link.
        manageToken: { type: String, default: null },
        // Which Acuity appointment type was booked, and so how long the call
        // is: AEP reviews are the 30-minute types, everything else 45.
        aep: { type: Boolean, default: false },
        // The wizard is Eastern-only: the slot picker renders in this zone and the
        // card says "Eastern Time", so the booked time must be rendered in it too
        // -- never the browser's zone (a Pacific client saw "1:00 PM · Eastern").
        timezone: { type: String, default: 'America/New_York' },
    },
    computed: {
        // Mirrors flow/scheduling/appointment_types.py — the same minutes
        // Acuity blocks on the advisor's calendar.
        durationMinutes () { return this.aep ? 30 : 45 },
        durationLabel () { return `${this.durationMinutes} minutes` },
        firstName () { return this.client.first_name || 'there' },
        manageUrl () { return this.manageToken ? `/scheduled?token=${encodeURIComponent(this.manageToken)}` : null },
        isEmail () { return this.method === 'email' || this.method === 'survey' },
        whenLabel () {
            if (!this.time) return ''
            return moment.tz(this.time, this.timezone).format('dddd, MMMM D [at] h:mm A')
        },
        guestNames () {
            return this.guests
                .map(g => ((g.first || '') + ' ' + (g.last || '')).trim())
                .filter(Boolean)
                .join(', ')
        },
        surveyPeople () {
            const list = [{ name: this.client.first_name || 'You', email: this.client.email }]
            this.guests.forEach((g) => {
                if (g.needsGuidance && g.email) {
                    list.push({ name: ((g.first || '') + ' ' + (g.last || '')).trim(), email: g.email })
                }
            })
            return list
        },
        // Block out exactly the booked appointment type's length, so a
        // 30-minute AEP review doesn't eat 45 minutes of the client's day.
        calEvent () {
            const start = moment(this.time)
            const end = start.clone().add(this.durationMinutes, 'minutes')
            const title = 'Doctor’s Choice consultation'
            const details = this.method === 'video'
                ? 'Your video consultation with a licensed Doctor’s Choice advisor. The Zoom link is in your confirmation email.'
                : 'A licensed Doctor’s Choice advisor will call you at the scheduled time.'
            return { start, end, title, details }
        },
        googleCalUrl () {
            const e = this.calEvent
            const fmt = m => m.utc().format('YYYYMMDDTHHmmss') + 'Z'
            const params = new URLSearchParams({
                action: 'TEMPLATE',
                text: e.title,
                dates: `${fmt(e.start)}/${fmt(e.end)}`,
                details: e.details,
            })
            return `https://calendar.google.com/calendar/render?${params.toString()}`
        },
        icsHref () {
            const e = this.calEvent
            const fmt = m => m.utc().format('YYYYMMDDTHHmmss') + 'Z'
            const esc = s => String(s || '').replace(/([,;\\])/g, '\\$1').replace(/\n/g, '\\n')
            const lines = [
                'BEGIN:VCALENDAR',
                'VERSION:2.0',
                'PRODID:-//Doctor’s Choice//Scheduler//EN',
                'BEGIN:VEVENT',
                `UID:${e.start.valueOf()}-dc@doctorschoiceusa.com`,
                `DTSTAMP:${fmt(moment())}`,
                `DTSTART:${fmt(e.start)}`,
                `DTEND:${fmt(e.end)}`,
                `SUMMARY:${esc(e.title)}`,
                `DESCRIPTION:${esc(e.details)}`,
                'END:VEVENT',
                'END:VCALENDAR',
            ]
            return 'data:text/calendar;charset=utf-8,' + encodeURIComponent(lines.join('\r\n'))
        },
        icsFilename () { return 'doctors-choice-consultation.ics' },
    },
}
